<template lang="html">
  <BaseLoading  :spinning="clubTeamHighlightsLoading">
    <div class="events-list-wrap create-profile-wrapper">
      <div class="top-head">
        <div class="container">
          <div class="list-wrap padding-b-10px">
            <div class="back">
              <div
                @click="handleBackClick"
                class="d-flex button-container pointer-hover"
                v-if="!hideButton"
              >
                <a-icon class="margin-left-25px" type="arrow-left" />
                <span class="margin-l-1">
                  Back to profile
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="events-content-wrap">
          <div class="head">
            <div class="head-title">
              <div class="name">{{ club.clubName }}</div>
              <h2 class="form-title">Club Team Highlights</h2>
            </div>
            <BaseButton
              v-if="isOwner"
              type="primary"
              class="add-event-btn"
              icon="plus"
              @click="newHighlight"
              >Add New Highlight</BaseButton
            >
          </div>
          <div class="roster-wrap">
            <a-row :gutter="[24, 32]">
              <a-col
                :xs="24"
                :sm="12"
                :md="8"
                :lg="6"
                v-for="(item, index) in clubTeamHighlights"
                :key="index"
              >
                <CardView :club-team-highlight="item" />
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>
  </BaseLoading>
</template>

<script>
import CardView from "./card";
import { mapGetters } from "vuex";
import { Base } from "@/models";

const CLUB_TEAM_HIGHLIGHT_STORE = "clubTeamHighlightStore";
const CLUB_STORE_KEY = "clubStore";

export default {
  components: {
    CardView
  },
  mounted() {
    this.dispatcher();
  },
  computed: {
    ...mapGetters({
      clubTeamHighlights: `${CLUB_TEAM_HIGHLIGHT_STORE}/clubTeamHighlights`,
      clubTeamHighlightsLoading: `${CLUB_TEAM_HIGHLIGHT_STORE}/clubTeamHighlightsLoading`,
      club: `${CLUB_STORE_KEY}/club`
    }),
    clubId() {
      return this.$route.params.id || localStorage["club-id"];
    },
    profileId() {
      return Base.profileId();
    },
    hideButton() {
      return (
        localStorage["club-id"] === (this.$route.params.id || this.club.id)
      );
    },
    isOwner() {
      return this.clubId === localStorage["club-id"];
    }
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(
        `${CLUB_TEAM_HIGHLIGHT_STORE}/getClubTeamHighlights`,
        {
          id: this.clubId,
          limit: 20,
          page: 1
        }
      );
      this.$store.dispatch(`${CLUB_STORE_KEY}/getClub`, {
        id: this.clubId
      });
    },
    handleBackClick() {
      this.$router.push(
        `/${this.$route.params.profileId}/club_profile/${this.$route.params.id}/summary`
      );
    },
    newHighlight() {
      this.$router.push(`/${this.profileId}/club/team_highlights/new`);
    }
  }
};
</script>

<style lang="scss" scoped>
.events-list-wrap {
  .back-button-wrapper {
    padding: 25px;
    color: #2a328a;
    display: block;
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    background: white;
    height: 5rem;
    .button-container {
      width: 100%;
      place-items: center;
      margin-left: 20rem;
    }
  }
  .events-content-wrap {
    .head {
      .head-title {
        padding-bottom: 30px;
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .button-container {
    width: 100%;
    place-items: center;
    margin-left: 0rem;
  }
}
</style>
